import { Component, OnInit } from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Api, User} from '../../providers';
import {HomePage} from '../home/home.page';

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit {
    public users:any
    public uid:string=''
    public type:string
    constructor(public api:Api, public user: User, public modalController: ModalController) {}

    ngOnInit() {
      this.getUsers()
    }
    dismissModal(){
        this.modalController.dismiss({
            'dismissed': true
        });
    }
    async presentHome(user) {
        const modal = await this.modalController.create({
            component: HomePage,
            // cssClass: 'my-custom-class',
            componentProps: {
                uid:user.uid,
                img:user.img,
                name:user.name,
                owner:user.owner
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
    }
    async getUsers(){
        this.user.myLoading()
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("uid", this.uid);
        formData.append("type", this.type);
        const upload$ = this.api.post("users/get", formData).subscribe(mres => {
            this.user.dismissLoading()
            this.user.checkStatus(mres,mres=> {
                  this.users = mres["data"];
            },res=>{})
        },err=>{
            this.user.dismissLoading()
        });
    }
}
